import React, { useState, useEffect, useRef } from "react";
import { host } from "./script/variables";

// ─── SVG Illustrations ─────────────────────────────────────────────────────

const IlluAI = () => (
  <svg viewBox="0 0 200 160" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="20" y="30" width="160" height="100" rx="14" fill="#FFF3E0" stroke="#FF6B35" strokeWidth="2"/>
    <rect x="36" y="48" width="90" height="10" rx="5" fill="#FFCCAA"/>
    <rect x="36" y="66" width="70" height="8" rx="4" fill="#FFE0C8"/>
    <rect x="36" y="82" width="80" height="8" rx="4" fill="#FFE0C8"/>
    <rect x="36" y="98" width="50" height="8" rx="4" fill="#FFE0C8"/>
    <circle cx="155" cy="75" r="22" fill="#FF6B35"/>
    <text x="155" y="81" textAnchor="middle" fontSize="20" fill="white">🤖</text>
    <path d="M130 55 Q142 48 148 58" stroke="#FF6B35" strokeWidth="2" strokeDasharray="4 2" fill="none"/>
    <circle cx="126" cy="55" r="3" fill="#F7B731"/>
    <circle cx="165" cy="105" r="8" fill="#F7B731" opacity="0.7"/>
    <circle cx="40" cy="120" r="5" fill="#FF6B35" opacity="0.4"/>
    <circle cx="170" cy="40" r="4" fill="#FF6B35" opacity="0.3"/>
  </svg>
);

const IlluInventory = () => (
  <svg viewBox="0 0 200 160" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="15" y="20" width="75" height="95" rx="10" fill="#E3F9F7" stroke="#2EC4B6" strokeWidth="1.5"/>
    <rect x="25" y="35" width="55" height="8" rx="4" fill="#2EC4B6" opacity="0.5"/>
    <rect x="25" y="50" width="40" height="6" rx="3" fill="#2EC4B6" opacity="0.3"/>
    <rect x="25" y="63" width="48" height="6" rx="3" fill="#2EC4B6" opacity="0.3"/>
    <rect x="25" y="76" width="35" height="6" rx="3" fill="#2EC4B6" opacity="0.3"/>
    <rect x="25" y="89" width="42" height="6" rx="3" fill="#2EC4B6" opacity="0.3"/>
    <rect x="110" y="20" width="75" height="95" rx="10" fill="#FFF8E1" stroke="#F7B731" strokeWidth="1.5"/>
    <rect x="120" y="35" width="55" height="8" rx="4" fill="#F7B731" opacity="0.6"/>
    <rect x="120" y="50" width="40" height="6" rx="3" fill="#F7B731" opacity="0.3"/>
    <rect x="120" y="63" width="48" height="6" rx="3" fill="#F7B731" opacity="0.3"/>
    <rect x="120" y="76" width="35" height="6" rx="3" fill="#F7B731" opacity="0.3"/>
    <path d="M90 67 L110 67" stroke="#555" strokeWidth="2" strokeDasharray="3 2"/>
    <polygon points="108,62 115,67 108,72" fill="#555"/>
    <rect x="55" y="125" width="90" height="18" rx="9" fill="#2EC4B6"/>
    <text x="100" y="138" textAnchor="middle" fontSize="9" fill="white" fontWeight="bold">AUTO UPDATED ✓</text>
  </svg>
);

const IlluExpense = () => (
  <svg viewBox="0 0 200 160" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="30" y="15" width="140" height="100" rx="12" fill="#FFFDE7" stroke="#F7B731" strokeWidth="2"/>
    <rect x="30" y="15" width="140" height="28" rx="12" fill="#F7B731"/>
    <rect x="30" y="30" width="140" height="13" fill="#F7B731"/>
    <text x="100" y="34" textAnchor="middle" fontSize="10" fill="white" fontWeight="bold">Monthly P&amp;L Report</text>
    <rect x="44" y="55" width="30" height="45" rx="4" fill="#10B981" opacity="0.8"/>
    <rect x="82" y="65" width="30" height="35" rx="4" fill="#10B981" opacity="0.6"/>
    <rect x="120" y="50" width="30" height="50" rx="4" fill="#10B981"/>
    <line x1="42" y1="100" x2="158" y2="100" stroke="#E0D8C0" strokeWidth="1.5"/>
    <text x="59" y="112" textAnchor="middle" fontSize="8" fill="#888">Apr</text>
    <text x="97" y="112" textAnchor="middle" fontSize="8" fill="#888">May</text>
    <text x="135" y="112" textAnchor="middle" fontSize="8" fill="#888">Jun</text>
    <circle cx="155" cy="130" r="16" fill="#F7B731"/>
    <text x="155" y="135" textAnchor="middle" fontSize="14">💰</text>
  </svg>
);

const IlluStaff = () => (
  <svg viewBox="0 0 200 160" fill="none" xmlns="http://www.w3.org/2000/svg">
    {[40, 90, 140].map((x, i) => (
      <g key={i}>
        <circle cx={x} cy="55" r="18" fill={["#FFE0D0","#E8D5FF","#D0F0EC"][i]} stroke={["#FF6B35","#A855F7","#2EC4B6"][i]} strokeWidth="1.5"/>
        <text x={x} y="61" textAnchor="middle" fontSize="16">{["👨‍🍳","💁","🧑‍💼"][i]}</text>
        <rect x={x-22} y="78" width="44" height="32" rx="8" fill={["#FFF3EE","#F5EEFF","#E8FAFA"][i]} stroke={["#FF6B35","#A855F7","#2EC4B6"][i]} strokeWidth="1"/>
        <rect x={x-16} y="85" width="32" height="5" rx="2.5" fill={["#FF6B35","#A855F7","#2EC4B6"][i]} opacity="0.5"/>
        <rect x={x-16} y="96" width="22" height="4" rx="2" fill={["#FF6B35","#A855F7","#2EC4B6"][i]} opacity="0.3"/>
      </g>
    ))}
    <rect x="20" y="120" width="160" height="22" rx="11" fill="#F7B731" opacity="0.15" stroke="#F7B731" strokeWidth="1"/>
    <text x="100" y="135" textAnchor="middle" fontSize="9" fill="#B8860B" fontWeight="bold">✓ Salary Processed • ✓ Attendance Marked</text>
  </svg>
);

const IlluTable = () => (
  <svg viewBox="0 0 200 160" fill="none" xmlns="http://www.w3.org/2000/svg">
    {[[30,25],[100,25],[170,25],[30,85],[100,85],[170,85]].map(([x,y],i) => (
      <g key={i}>
        <rect x={x-20} y={y} width="40" height="40" rx="8"
          fill={i===2?"#DCFCE7":i===4?"#FEF9C3":i===0?"#FFE4E1":"#F9FAFB"}
          stroke={i===2?"#10B981":i===4?"#F7B731":i===0?"#EF4444":"#CBD5E1"}
          strokeWidth="1.5"/>
        <text x={x} y={y+26} textAnchor="middle" fontSize="18">
          {i===2?"✅":i===4?"⏳":i===0?"🚫":"🪑"}
        </text>
        <text x={x} y={y+38} textAnchor="middle" fontSize="7" fill="#666">
          {i===2?"Occupied":i===4?"Waiting":i===0?"Reserved":"Free"}
        </text>
      </g>
    ))}
    <rect x="50" y="132" width="100" height="16" rx="8" fill="#EF4444"/>
    <text x="100" y="143" textAnchor="middle" fontSize="8" fill="white" fontWeight="bold">📱 QR Order Active</text>
  </svg>
);

const IlluReports = () => (
  <svg viewBox="0 0 200 160" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="chartFill" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#10B981" stopOpacity="0.3"/>
        <stop offset="100%" stopColor="#10B981" stopOpacity="0"/>
      </linearGradient>
    </defs>
    <rect x="20" y="20" width="160" height="120" rx="12" fill="#F0FDF4" stroke="#10B981" strokeWidth="1.5"/>
    <polyline points="35,115 60,85 85,95 110,60 135,70 165,35" stroke="#10B981" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
    {[[35,115],[60,85],[85,95],[110,60],[135,70],[165,35]].map(([x,y],i) => (
      <circle key={i} cx={x} cy={y} r="4" fill="#10B981"/>
    ))}
    <rect x="110" y="30" width="58" height="22" rx="6" fill="#10B981"/>
    <text x="139" y="45" textAnchor="middle" fontSize="9" fill="white" fontWeight="bold">↑ 24% Growth</text>
    <line x1="35" y1="120" x2="165" y2="120" stroke="#D1FAE5" strokeWidth="1"/>
    <text x="35" y="135" fontSize="7" fill="#10B981">Apr</text>
    <text x="75" y="135" fontSize="7" fill="#10B981">May</text>
    <text x="115" y="135" fontSize="7" fill="#10B981">Jun</text>
    <text x="150" y="135" fontSize="7" fill="#10B981">Jul</text>
  </svg>
);

const IlluOnlineOrder = () => (
  <svg viewBox="0 0 200 160" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="55" y="10" width="90" height="140" rx="16" fill="#FFF3E0" stroke="#FF6B35" strokeWidth="2"/>
    <rect x="65" y="25" width="70" height="45" rx="8" fill="#FFE0CC"/>
    <text x="100" y="52" textAnchor="middle" fontSize="28">🍛</text>
    <rect x="65" y="78" width="70" height="8" rx="4" fill="#FF6B35" opacity="0.4"/>
    <rect x="65" y="92" width="50" height="6" rx="3" fill="#FF6B35" opacity="0.2"/>
    <rect x="65" y="106" width="70" height="22" rx="8" fill="#FF6B35"/>
    <text x="100" y="121" textAnchor="middle" fontSize="9" fill="white" fontWeight="bold">ORDER NOW →</text>
    <circle cx="30" cy="55" r="18" fill="#25D366"/>
    <text x="30" y="61" textAnchor="middle" fontSize="16">💬</text>
    <path d="M48 55 L55 55" stroke="#555" strokeWidth="1.5" strokeDasharray="3 2"/>
    <text x="30" y="82" textAnchor="middle" fontSize="7" fill="#25D366" fontWeight="bold">WhatsApp</text>
    <rect x="140" y="38" width="42" height="18" rx="9" fill="#FF6B35" opacity="0.15" stroke="#FF6B35" strokeWidth="1"/>
    <text x="161" y="51" textAnchor="middle" fontSize="8" fill="#FF6B35" fontWeight="bold">0% Fee</text>
  </svg>
);

const IlluOrderMgmt = () => (
  <svg viewBox="0 0 200 160" fill="none" xmlns="http://www.w3.org/2000/svg">
    {[
      {x:15, label:"New", emoji:"📥", color:"#3B82F6", bg:"#EFF6FF", count:4},
      {x:65, label:"Cooking", emoji:"👨‍🍳", color:"#F7B731", bg:"#FFFBEB", count:3},
      {x:115, label:"Ready", emoji:"✅", color:"#10B981", bg:"#ECFDF5", count:2},
      {x:165, label:"Done", emoji:"🛵", color:"#A855F7", bg:"#F5F3FF", count:1},
    ].map((col) => (
      <g key={col.label}>
        <rect x={col.x-10} y="15" width="45" height="130" rx="8" fill={col.bg} stroke={col.color} strokeWidth="1.2" opacity="0.8"/>
        <rect x={col.x-6} y="20" width="37" height="18" rx="5" fill={col.color}/>
        <text x={col.x+12.5} y="33" textAnchor="middle" fontSize="7" fill="white" fontWeight="bold">{col.label}</text>
        {Array.from({length:col.count}).map((_,j) => (
          <g key={j}>
            <rect x={col.x-5} y={45+j*25} width="35" height="18" rx="4" fill="white" stroke={col.color} strokeWidth="0.8"/>
            <text x={col.x+12.5} y={45+j*25+8} textAnchor="middle" fontSize="10">{col.emoji}</text>
            <rect x={col.x} y={45+j*25+12} width="20" height="3" rx="1.5" fill={col.color} opacity="0.3"/>
          </g>
        ))}
      </g>
    ))}
  </svg>
);

const IlluDiscovery = () => (
  <svg viewBox="0 0 200 160" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="100" cy="80" r="65" fill="#FFF8E1" stroke="#F7B731" strokeWidth="1.5"/>
    <circle cx="100" cy="80" r="45" fill="none" stroke="#F7B731" strokeWidth="0.8" strokeDasharray="4 3" opacity="0.5"/>
    <circle cx="100" cy="80" r="25" fill="none" stroke="#F7B731" strokeWidth="0.8" strokeDasharray="3 2" opacity="0.3"/>
    {[[55,35],[150,45],[165,95],[130,145],[60,140],[30,90]].map(([x,y],i) => (
      <g key={i}>
        <circle cx={x} cy={y} r="14" fill="white" stroke="#FF6B35" strokeWidth="1.5"/>
        <text x={x} y={y+5} textAnchor="middle" fontSize="12">🍽️</text>
        <line x1={x} y1={y} x2="100" y2="80" stroke="#FF6B35" strokeWidth="0.8" strokeDasharray="3 2" opacity="0.4"/>
      </g>
    ))}
    <circle cx="100" cy="80" r="12" fill="#FF6B35"/>
    <text x="100" y="85" textAnchor="middle" fontSize="12" fill="white">📍</text>
  </svg>
);

const IlluMoments = () => (
  <svg viewBox="0 0 200 160" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="20" y="20" width="70" height="75" rx="10" fill="#FFF0F5" stroke="#EC4899" strokeWidth="1.5"/>
    <rect x="28" y="28" width="54" height="38" rx="6" fill="#FCE4EC"/>
    <text x="55" y="53" textAnchor="middle" fontSize="26">🍕</text>
    <text x="55" y="78" textAnchor="middle" fontSize="8" fill="#EC4899" fontWeight="bold">❤️ 142 Likes</text>
    <rect x="25" y="100" width="40" height="6" rx="3" fill="#EC4899" opacity="0.3"/>
    <rect x="110" y="10" width="70" height="75" rx="10" fill="#F0FFF4" stroke="#10B981" strokeWidth="1.5"/>
    <rect x="118" y="18" width="54" height="38" rx="6" fill="#D1FAE5"/>
    <text x="145" y="43" textAnchor="middle" fontSize="26">🍜</text>
    <text x="145" y="68" textAnchor="middle" fontSize="8" fill="#10B981" fontWeight="bold">⭐ 4.9 Rating</text>
    <rect x="115" y="90" width="40" height="6" rx="3" fill="#10B981" opacity="0.3"/>
    <rect x="55" y="110" width="90" height="35" rx="10" fill="#FFF3E0" stroke="#FF6B35" strokeWidth="1.5"/>
    <text x="100" y="130" textAnchor="middle" fontSize="9" fill="#FF6B35" fontWeight="bold">📸 Share Your Moment!</text>
    <text x="100" y="141" textAnchor="middle" fontSize="7" fill="#888">Customers become brand ambassadors</text>
  </svg>
);

const IlluMultiBranch = () => (
  <svg viewBox="0 0 200 160" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="60" y="10" width="80" height="45" rx="10" fill="#EDE9FE" stroke="#A855F7" strokeWidth="1.5"/>
    <text x="100" y="28" textAnchor="middle" fontSize="9" fill="#7C3AED" fontWeight="bold">📊 Main Dashboard</text>
    <rect x="70" y="35" width="60" height="8" rx="4" fill="#A855F7" opacity="0.3"/>
    <line x1="80" y1="55" x2="45" y2="90" stroke="#A855F7" strokeWidth="1.5" strokeDasharray="4 2"/>
    <line x1="100" y1="55" x2="100" y2="90" stroke="#A855F7" strokeWidth="1.5" strokeDasharray="4 2"/>
    <line x1="120" y1="55" x2="155" y2="90" stroke="#A855F7" strokeWidth="1.5" strokeDasharray="4 2"/>
    {[[20,90,"Delhi 🕌","#FF6B35","#FFF3EE"],[75,90,"Mumbai 🌊","#2EC4B6","#E3F9F7"],[130,90,"Pune 🎭","#F7B731","#FFFBEB"]].map(([x,y,city,c,bg])=>(
      <g key={city}>
        <rect x={x} y={y} width="50" height="50" rx="8" fill={bg} stroke={c} strokeWidth="1.5"/>
        <text x={x+25} y={y+20} textAnchor="middle" fontSize="8" fill={c} fontWeight="bold">{city}</text>
        <rect x={x+7} y={y+25} width="36" height="5" rx="2.5" fill={c} opacity="0.4"/>
        <rect x={x+7} y={y+35} width="25" height="5" rx="2.5" fill={c} opacity="0.25"/>
      </g>
    ))}
  </svg>
);

// ─── Feature Data ──────────────────────────────────────────────────────────

const features = [
  { Illus: IlluAI, tag: "AI-Powered", title: "Smart AI Onboarding", hindi: "आसान शुरुआत, AI के साथ", desc: "Menu upload karo — photo, PDF ya Excel — aur AI automatically items, prices aur categories extract kar leta hai. Ek ghante ka kaam, 5 minute mein.", highlight: "Menu scan se seedha live ho jao", color: "#E85D20", bg: "#FFF3E0" },
  { Illus: IlluInventory, tag: "Inventory", title: "Smart Inventory", hindi: "Stock ka hisaab, automatic", desc: "Vendor invoices ki photo lo — AI ingredients, quantities aur rates khud daal deta hai. Kabhi bhi stock khatam hone ki tension nahi.", highlight: "Invoice photo → Stock update", color: "#0EA5A0", bg: "#E3F9F7" },
  { Illus: IlluExpense, tag: "Expenses", title: "Easy Expense Tracking", hindi: "Kharcha track karo, bina jhanjhat ke", desc: "Bijli bill, rent, raw material — sab ek jagah. AI receipts se expenses extract karta hai. Mahine ka P&L ek click mein dekho.", highlight: "Har expense, ek dashboard mein", color: "#D48C00", bg: "#FFFDE7" },
  { Illus: IlluStaff, tag: "Staff", title: "Employee Management", hindi: "Staff ka record, seedha phone pe", desc: "Attendance, salary, advances — sab digital. Chutti ki request bhi app se milegi. Chef se waiter tak, sab manage karo ek jagah se.", highlight: "Salary slip bhi generate hoti hai", color: "#8B31D4", bg: "#F5F3FF" },
  { Illus: IlluTable, tag: "Dine-In", title: "Table Management", hindi: "Koi table empty nahi jayegi", desc: "QR code se customer khud order de sakta hai. Kitchen ko live updates milte hain. Table availability real-time mein dekho.", highlight: "QR Order + Live Kitchen Display", color: "#DC2626", bg: "#FFF5F5" },
  { Illus: IlluReports, tag: "Reports", title: "Detailed Sales Reports", hindi: "Kaun sa dish bikta hai sabse zyada?", desc: "Daily, weekly, monthly sales — graphs mein. Best-selling items, peak hours, top customers — sab data aapke haath mein.", highlight: "GST-ready reports bhi milti hain", color: "#059669", bg: "#F0FDF4" },
  { Illus: IlluOnlineOrder, tag: "Online Orders", title: "Direct Online Ordering", hindi: "Apna khud ka order link", desc: "Swiggy-Zomato commission nahi! Customers seedha aapke restaurant se order karte hain. WhatsApp pe link share karo aur orders aate rahein.", highlight: "Zero commission, 100% aapka", color: "#E85D20", bg: "#FFF3E0" },
  { Illus: IlluOrderMgmt, tag: "Operations", title: "Smart Order Management", hindi: "Order aaya, kitchen gaya, table pe aaya", desc: "Online, dine-in, takeaway — sabke orders ek jagah. Status track karo — accepted, preparing, ready, delivered.", highlight: "Kitchen + Counter sync hota hai", color: "#1D4ED8", bg: "#EFF6FF" },
  { Illus: IlluDiscovery, tag: "Discovery", title: "Listed on RestroPilots", hindi: "Lakho customers tak pahuncho", desc: "Aapka restaurant RestroPilots app pe list hoga jahan customers nearby restaurants dhundh ke direct order karte hain. Free mein zyada reach pao.", highlight: "Customers aapko khud dhundhenge", color: "#D48C00", bg: "#FFFDE7" },
  { Illus: IlluMoments, tag: "Engagement", title: "Happy Moments Sharing", hindi: "Customers hi banenge brand ambassadors", desc: "Customers apni food photos share karte hain directly restaurant ke page pe. Word-of-mouth marketing apne aap hoti hai.", highlight: "UGC se trust badhta hai", color: "#BE185D", bg: "#FFF0F5" },
  { Illus: IlluMultiBranch, tag: "Multi-Branch", title: "Multiple Restaurants", hindi: "Ek se zyada restaurant? Koi problem nahi", desc: "Delhi mein ek, Mumbai mein ek — dono ek hi dashboard se. Sales compare karo, menu sync karo, staff dekho. Expand karo bina headache ke.", highlight: "Chain owners ke liye perfect", color: "#8B31D4", bg: "#F5F3FF" },
];

const BACKEND_API = `${host}/api/enquiries/res-enquiry`; // Replace with actual API


// ─── Main Component ─────────────────────────────────────────────────────────

export default function MsFeatures() {
  const [form, setForm] = useState({ ownerName: "", phone: "", restaurantName: "" });
  const [status, setStatus] = useState("idle");
  const [errorMsg, setErrorMsg] = useState("");
  const [visibleCards, setVisibleCards] = useState(new Set());
  const cardRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setVisibleCards((prev) => new Set([...prev, parseInt(e.target.dataset.idx)]));
          }
        });
      },
      { threshold: 0.12 }
    );
    cardRefs.current.forEach((r) => r && observer.observe(r));
    return () => observer.disconnect();
  }, []);

  const handleChange = (e) => {
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
    setErrorMsg("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { ownerName, phone, restaurantName } = form;
    if (!ownerName.trim() || !phone.trim() || !restaurantName.trim()) {
      setErrorMsg("Sab fields bharna zaroori hai.");
      return;
    }
    if (!/^[6-9]\d{9}$/.test(phone.replace(/\s/g, ""))) {
      setErrorMsg("Valid 10-digit Indian mobile number daalo.");
      return;
    }
    setStatus("loading");
    try {
      const res = await fetch(BACKEND_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error();
      setStatus("success");
      setForm({ ownerName: "", phone: "", restaurantName: "" });
    } catch {
      setStatus("idle");
      setErrorMsg("Kuch galat hua. Thodi der baad try karein.");
    }
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Baloo+2:wght@400;500;600;700;800&family=Noto+Sans+Devanagari:wght@400;600;700&display=swap');

        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

        :root {
          --bg: #FFFAF4;
          --bg2: #FFF5E8;
          --surface: #FFFFFF;
          --border: #EDE0CC;
          --text: #1C1009;
          --text2: #4A3728;
          --muted: #9C8070;
          --accent: #E85D20;
          --accent2: #F0A500;
          --radius: 18px;
          --font: 'Baloo 2', cursive;
          --hindi: 'Noto Sans Devanagari', sans-serif;
          --shadow: 0 2px 16px rgba(100,60,20,0.08);
          --shadow-lg: 0 10px 40px rgba(100,60,20,0.15);
        }

        .ms-wrap {
          background: var(--bg);
          color: var(--text);
          font-family: var(--font);
          min-height: 100vh;
          overflow-x: hidden;
        }

        /* HERO */
        .ms-hero {
          position: relative;
          padding: 72px 24px 64px;
          text-align: center;
          overflow: hidden;
          background: linear-gradient(160deg, #FFF8EE 0%, #FFFAF4 55%, #F2FAF8 100%);
          border-bottom: 1.5px solid var(--border);
        }
        .ms-blob1 {
          position: absolute; top: -80px; right: -80px;
          width: 380px; height: 380px; border-radius: 50%;
          background: radial-gradient(circle, rgba(232,93,32,0.10) 0%, transparent 65%);
          pointer-events: none;
        }
        .ms-blob2 {
          position: absolute; bottom: -60px; left: -60px;
          width: 300px; height: 300px; border-radius: 50%;
          background: radial-gradient(circle, rgba(46,196,182,0.10) 0%, transparent 65%);
          pointer-events: none;
        }
        .ms-float {
          position: absolute;
          font-size: 2.2rem;
          animation: floatY 4s ease-in-out infinite;
          opacity: 0.45;
          user-select: none;
          pointer-events: none;
        }
        @keyframes floatY {
          0%,100% { transform: translateY(0) rotate(-4deg); }
          50% { transform: translateY(-13px) rotate(4deg); }
        }
        .ms-badge {
          display: inline-block;
          background: linear-gradient(90deg, rgba(232,93,32,0.10), rgba(240,165,0,0.10));
          border: 1.5px solid rgba(232,93,32,0.28);
          color: var(--accent);
          font-size: 11.5px; font-weight: 700; letter-spacing: 1.5px;
          text-transform: uppercase; padding: 6px 18px;
          border-radius: 100px; margin-bottom: 22px;
        }
        .ms-hero h1 {
          font-size: clamp(2.2rem, 5.5vw, 4rem);
          font-weight: 800; line-height: 1.13;
          color: var(--text); max-width: 720px;
          margin: 0 auto 18px; position: relative; z-index: 1;
        }
        .ms-hero h1 em {
          font-style: normal;
          background: linear-gradient(90deg, var(--accent) 0%, var(--accent2) 100%);
          -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;
        }
        .ms-hero-sub {
          font-size: 16px; color: var(--text2);
          max-width: 500px; margin: 0 auto 38px;
          line-height: 1.75; font-family: var(--hindi);
          position: relative; z-index: 1;
        }
        .ms-cta-btn {
          display: inline-block;
          background: linear-gradient(90deg, var(--accent), #C84A10);
          color: white; font-family: var(--font);
          font-size: 15px; font-weight: 700;
          padding: 14px 34px; border-radius: 50px;
          text-decoration: none;
          box-shadow: 0 6px 22px rgba(232,93,32,0.38);
          transition: transform 0.2s, box-shadow 0.2s;
          margin-bottom: 48px; position: relative; z-index: 1;
          border: none; cursor: pointer;
        }
        .ms-cta-btn:hover { transform: translateY(-2px); box-shadow: 0 10px 30px rgba(232,93,32,0.48); }

        .ms-stats {
          display: flex; justify-content: center;
          background: white; border: 1.5px solid var(--border);
          border-radius: 20px; box-shadow: var(--shadow);
          max-width: 540px; margin: 0 auto; overflow: hidden;
          position: relative; z-index: 1;
        }
        .ms-stat {
          flex: 1; min-width: 90px;
          padding: 20px 14px; text-align: center;
          border-right: 1px solid var(--border);
        }
        .ms-stat:last-child { border-right: none; }
        .ms-stat-num { font-size: 1.8rem; font-weight: 800; color: var(--accent); line-height: 1; }
        .ms-stat-label { font-size: 10.5px; color: var(--muted); text-transform: uppercase; letter-spacing: 0.8px; margin-top: 4px; }

        /* SECTION HEADER */
        .ms-sec-head { text-align: center; padding: 64px 24px 36px; }
        .ms-sec-head h2 { font-size: clamp(1.7rem, 3.5vw, 2.7rem); font-weight: 800; color: var(--text); margin-bottom: 10px; }
        .ms-sec-head p { color: var(--muted); font-size: 15px; max-width: 420px; margin: 0 auto; font-family: var(--hindi); line-height: 1.65; }

        /* FEATURE GRID */
        .ms-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(310px, 1fr));
          gap: 22px; padding: 0 28px 64px;
          max-width: 1180px; margin: 0 auto;
        }
        .ms-card {
          background: var(--surface);
          border: 1.5px solid var(--border);
          border-radius: var(--radius);
          overflow: hidden;
          box-shadow: var(--shadow);
          transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
          opacity: 0; transform: translateY(28px);
          cursor: default;
        }
        .ms-card.vis {
          opacity: 1; transform: translateY(0);
          transition: opacity 0.55s ease, transform 0.55s ease, box-shadow 0.3s ease, border-color 0.3s ease;
        }
        .ms-card:hover { transform: translateY(-5px); box-shadow: var(--shadow-lg); border-color: var(--cc); }

        .ms-card-illus {
          height: 155px; display: flex;
          align-items: center; justify-content: center;
          padding: 10px 20px 4px;
          background: var(--cb);
        }
        .ms-card-illus svg { width: 100%; height: 100%; max-width: 200px; }
        .ms-card-body { padding: 20px 22px 22px; }
        .ms-card-tag {
          display: inline-block; font-size: 10px; font-weight: 700;
          letter-spacing: 1.4px; text-transform: uppercase;
          color: var(--cc); background: var(--cb);
          border: 1px solid var(--cc); padding: 3px 10px;
          border-radius: 100px; margin-bottom: 10px;
        }
        .ms-card-title { font-size: 18px; font-weight: 800; color: var(--text); line-height: 1.25; margin-bottom: 4px; }
        .ms-card-hindi { font-family: var(--hindi); font-size: 13px; color: var(--muted); margin-bottom: 11px; }
        .ms-card-desc { font-size: 13.5px; line-height: 1.72; color: var(--text2); margin-bottom: 16px; }
        .ms-card-pill {
          display: inline-flex; align-items: center; gap: 5px;
          font-size: 12px; font-weight: 600;
          color: var(--cc); background: var(--cb);
          border: 1.5px solid var(--cc); padding: 5px 13px;
          border-radius: 100px;
        }
        .ms-card-pill::before { content: '✓'; font-size: 11px; }

        /* BANNER */
        .ms-banner-wrap { padding: 0 28px 64px; max-width: 1180px; margin: 0 auto; }
        .ms-banner {
          background: linear-gradient(135deg, #FFFBF0 0%, #FFF5EE 50%, #F2FAF8 100%);
          border: 1.5px solid var(--border); border-radius: 24px;
          padding: 42px 40px; display: flex; align-items: center;
          gap: 32px; flex-wrap: wrap; box-shadow: var(--shadow);
          position: relative; overflow: hidden;
        }
        .ms-banner::after {
          content: '🗺️'; position: absolute; right: -8px; top: -8px;
          font-size: 9rem; opacity: 0.05; pointer-events: none;
        }
        .ms-banner-icon {
          width: 70px; height: 70px;
          background: linear-gradient(135deg, var(--accent2), var(--accent));
          border-radius: 20px; display: flex; align-items: center; justify-content: center;
          font-size: 2rem; flex-shrink: 0;
          box-shadow: 0 6px 20px rgba(240,165,0,0.3);
        }
        .ms-banner-text { flex: 1; min-width: 220px; }
        .ms-banner-text h3 { font-size: 1.35rem; font-weight: 800; margin-bottom: 8px; color: var(--text); }
        .ms-banner-text p { color: var(--text2); font-size: 14px; line-height: 1.65; font-family: var(--hindi); }
        .ms-banner-btn {
          background: linear-gradient(90deg, var(--accent), #C84A10); color: white;
          border: none; padding: 13px 26px; border-radius: 14px;
          font-family: var(--font); font-size: 14px; font-weight: 700;
          cursor: pointer; text-decoration: none; display: inline-block;
          box-shadow: 0 4px 14px rgba(232,93,32,0.3);
          transition: transform 0.2s, box-shadow 0.2s; white-space: nowrap;
        }
        .ms-banner-btn:hover { transform: translateY(-2px); box-shadow: 0 8px 20px rgba(232,93,32,0.42); }

        /* FORM */
        .ms-form-sec {
          background: linear-gradient(160deg, #FFF8F0, #FFFAF4 50%, #F2FAF8);
          border-top: 1.5px solid var(--border); padding: 72px 24px 80px;
          position: relative; overflow: hidden;
        }
        .ms-form-sec::before {
          content: ''; position: absolute; top: -100px; right: -100px;
          width: 400px; height: 400px; border-radius: 50%;
          background: radial-gradient(circle, rgba(232,93,32,0.07) 0%, transparent 65%);
          pointer-events: none;
        }
        .ms-form-inner { max-width: 540px; margin: 0 auto; position: relative; z-index: 1; }
        .ms-form-head { text-align: center; margin-bottom: 36px; }
        .ms-form-head h2 { font-size: clamp(1.7rem, 3.2vw, 2.3rem); font-weight: 800; margin-bottom: 10px; }
        .ms-form-head p { color: var(--muted); font-size: 14.5px; font-family: var(--hindi); line-height: 1.65; }

        .ms-form-card {
          background: white; border: 1.5px solid var(--border);
          border-radius: 24px; padding: 36px 36px 32px;
          box-shadow: 0 8px 44px rgba(100,60,20,0.10);
        }
        .ms-field { display: flex; flex-direction: column; gap: 7px; margin-bottom: 18px; }
        .ms-field label { font-size: 13px; font-weight: 700; color: var(--text2); }
        .ms-field input {
          background: var(--bg); border: 1.5px solid var(--border);
          border-radius: 12px; color: var(--text);
          font-family: var(--font); font-size: 15px;
          padding: 13px 16px; outline: none; width: 100%;
          transition: border-color 0.2s, box-shadow 0.2s;
        }
        .ms-field input::placeholder { color: #C8B8A8; }
        .ms-field input:focus { border-color: var(--accent); background: white; box-shadow: 0 0 0 4px rgba(232,93,32,0.09); }

        .ms-err {
          background: #FFF0EE; border: 1px solid #FFCCC5; color: #C0392B;
          border-radius: 10px; padding: 11px 14px; font-size: 13px;
          margin-bottom: 16px; display: flex; align-items: center; gap: 7px;
        }
        .ms-submit-btn {
          background: linear-gradient(90deg, var(--accent), #C84A10); color: white;
          border: none; padding: 15px; border-radius: 14px;
          font-family: var(--font); font-size: 16px; font-weight: 700;
          cursor: pointer; width: 100%;
          display: flex; align-items: center; justify-content: center; gap: 8px;
          box-shadow: 0 5px 20px rgba(232,93,32,0.35);
          transition: transform 0.2s, box-shadow 0.2s, opacity 0.2s; margin-top: 4px;
        }
        .ms-submit-btn:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 8px 26px rgba(232,93,32,0.48); }
        .ms-submit-btn:disabled { opacity: 0.62; cursor: not-allowed; }

        .ms-success-box {
          text-align: center; padding: 40px 20px;
          background: #F0FDF4; border: 1.5px solid #A7F3D0; border-radius: 18px;
        }
        .ms-success-box .si { font-size: 3rem; margin-bottom: 14px; }
        .ms-success-box h3 { font-size: 1.4rem; font-weight: 800; color: #059669; margin-bottom: 8px; }
        .ms-success-box p { color: var(--muted); font-size: 14px; font-family: var(--hindi); line-height: 1.6; }

        .ms-trust {
          display: flex; justify-content: center; gap: 24px;
          flex-wrap: wrap; margin-top: 26px; padding-top: 22px;
          border-top: 1.5px solid var(--border);
        }
        .ms-trust-item { display: flex; align-items: center; gap: 6px; font-size: 13px; color: var(--muted); }

        /* FOOTER */
        .ms-footer {
          text-align: center; padding: 22px 24px;
          color: var(--muted); font-size: 13px;
          border-top: 1.5px solid var(--border); background: white;
        }
        .ms-footer a { color: var(--accent); text-decoration: none; font-weight: 600; }

        @keyframes spin { to { transform: rotate(360deg); } }
        .ms-spin {
          width: 18px; height: 18px;
          border: 2px solid rgba(255,255,255,0.38);
          border-top-color: white; border-radius: 50%;
          animation: spin 0.7s linear infinite;
        }

        @media (max-width: 640px) {
          .ms-grid { grid-template-columns: 1fr; padding: 0 16px 40px; }
          .ms-banner { padding: 26px 22px; }
          .ms-banner-wrap { padding: 0 16px 40px; }
          .ms-hero { padding: 52px 16px 48px; }
          .ms-form-card { padding: 26px 20px; }
          .ms-stats { flex-wrap: wrap; }
          .ms-stat { min-width: 80px; }
        }
      `}</style>

      <div className="ms-wrap">

        {/* HERO */}
        <section className="ms-hero">
          <div className="ms-blob1" />
          <div className="ms-blob2" />
          {[["🍛",{top:"12%",left:"4%"},"0s"],["🍕",{top:"16%",right:"6%"},"0.6s"],["🥘",{bottom:"14%",left:"6%"},"1.2s"],["🧆",{bottom:"20%",right:"4%"},"0.9s"]].map(([e,s,d])=>(
            <span key={e} className="ms-float" style={{...s, animationDelay:d}}>{e}</span>
          ))}

          <div className="ms-badge">🍽️ RestroPilots — Restaurant Software</div>
          <h1>Apna Restaurant<br /><em>Smart Banao</em></h1>
          <p className="ms-hero-sub">
            Chhote dhabe se lekar bade restaurants tak — sab kuch ek app mein manage karo. AI ki madad se, koi technical knowledge nahi chahiye.
          </p>
          <a href="#enquiry" className="ms-cta-btn">Free Demo Book Karo 🚀</a>

          <div className="ms-stats">
            {[{num:"11+",label:"Features"},{num:"0%",label:"Commission"},{num:"₹0",label:"Setup Cost"},{num:"24/7",label:"Support"}].map((s)=>(
              <div className="ms-stat" key={s.label}>
                <div className="ms-stat-num">{s.num}</div>
                <div className="ms-stat-label">{s.label}</div>
              </div>
            ))}
          </div>
        </section>

        {/* SECTION HEADER */}
        <div className="ms-sec-head">
          <h2>Sab Kuch Ek Jagah 🚀</h2>
          <p>Restaurant chalana ab mushkil nahi — dekho kya kya kar sakte ho</p>
        </div>

        {/* FEATURE CARDS */}
        <div className="ms-grid">
          {features.map(({ Illus, tag, title, hindi, desc, highlight, color, bg }, i) => (
            <div
              key={title}
              className={`ms-card${visibleCards.has(i) ? " vis" : ""}`}
              data-idx={i}
              ref={(el) => (cardRefs.current[i] = el)}
              style={{ "--cc": color, "--cb": bg, transitionDelay: `${(i % 3) * 70}ms` }}
            >
              <div className="ms-card-illus"><Illus /></div>
              <div className="ms-card-body">
                <div className="ms-card-tag">{tag}</div>
                <div className="ms-card-title">{title}</div>
                <div className="ms-card-hindi">{hindi}</div>
                <div className="ms-card-desc">{desc}</div>
                <div className="ms-card-pill">{highlight}</div>
              </div>
            </div>
          ))}
        </div>

        {/* PLATFORM BANNER */}
        <div className="ms-banner-wrap">
          <div className="ms-banner">
            <div className="ms-banner-icon">🗺️</div>
            <div className="ms-banner-text">
              <h3>RestroPilots Platform pe Free Listing</h3>
              <p>Aapka restaurant restropilots.com aur app pe dikhai dega — jahan thousands customers nearby restaurants dhundh ke seedha order karte hain. Swiggy-Zomato se alag, yahan commission zero hai.</p>
            </div>
            <a href="https://restropilots.com" target="_blank" rel="noreferrer" className="ms-banner-btn">Platform Dekho →</a>
          </div>
        </div>

        {/* ENQUIRY FORM */}
        <section className="ms-form-sec" id="enquiry">
          <div className="ms-form-inner">
            <div className="ms-form-head">
              <div className="ms-badge" style={{marginBottom:16}}>📞 Free Demo Lo</div>
              <h2>Aaj Hi Shuru Karo</h2>
              <p>Apna naam aur number do — hamaari team 24 ghante mein aapse baat karegi aur free demo degi.</p>
            </div>

            <div className="ms-form-card">
              {status === "success" ? (
                <div className="ms-success-box">
                  <div className="si">🎉</div>
                  <h3>Bahut Badhiya!</h3>
                  <p>Aapki enquiry mil gayi. Hamaari team jald hi aapse contact karegi. Tab tak restropilots.com explore karo!</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} noValidate>
                  <div className="ms-field">
                    <label htmlFor="ownerName">Owner Ka Naam *</label>
                    <input id="ownerName" name="ownerName" type="text" placeholder="Jaise: Ramesh Kumar" value={form.ownerName} onChange={handleChange} autoComplete="name" />
                  </div>
                  <div className="ms-field">
                    <label htmlFor="phone">Mobile Number *</label>
                    <input id="phone" name="phone" type="tel" placeholder="10-digit number daalo" value={form.phone} onChange={handleChange} maxLength={10} autoComplete="tel" />
                  </div>
                  <div className="ms-field">
                    <label htmlFor="restaurantName">Restaurant Ka Naam *</label>
                    <input id="restaurantName" name="restaurantName" type="text" placeholder="Jaise: Sharma Ji Ka Dhaba" value={form.restaurantName} onChange={handleChange} autoComplete="organization" />
                  </div>
                  {errorMsg && <div className="ms-err"><span>⚠️</span>{errorMsg}</div>}
                  <button className="ms-submit-btn" type="submit" disabled={status==="loading"}>
                    {status==="loading" ? (<><span className="ms-spin"/>Bhej rahe hain…</>) : "Free Demo Book Karo 🚀"}
                  </button>
                </form>
              )}
              <div className="ms-trust">
                {[["🔒","Data Safe Rahega"],["💸","Bilkul Free Demo"],["📞","Hindi Mein Support"]].map(([icon,text])=>(
                  <div className="ms-trust-item" key={text}><span>{icon}</span><span>{text}</span></div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* FOOTER */}
        <footer className="ms-footer">
          Powered by <a href="https://restropilots.com" target="_blank" rel="noreferrer">RestroPilots</a> — India ka Smart Restaurant Management Platform
        </footer>

      </div>
    </>
  );
}